(function () {
  'use strict';

  angular
      .module('tfc.sso')
      .controller('ForgotPasswordCtrl', ForgotPasswordCtrl);

  // @ngInject
  function ForgotPasswordCtrl($stateParams, Auth) {
    var vm = this;

    vm.sent = false;
    vm.expired = $stateParams.expired;
    vm.email = $stateParams.email;

    vm.submit = function () {
      Auth.forgotPassword(vm.email).then(function () {
        vm.sent = true;
      });
    };
  }

})();
